import React from 'react';
import notify from '@/lib/notify/notify';
import { sessionLoad } from '@/lib/session/session.bootstrap';
import { useAppDispatch } from '@/store/store.hooks';

export default function useSignedIn(): () => void {
    const dispatch = useAppDispatch();
    return React.useCallback(() => {
        void sessionLoad(dispatch).then((loaded) => {
            if (!loaded) notify.error('Accesso non completato', 'Il tuo account è stato riconosciuto ma la dashboard non ti riconosce o non risponde: riprova fra poco o chiedi all’amministratore.');
        });
    }, [dispatch]);
}
